import { Playground } from "./Playground";
import "./index.css";

export function App() {
  return (
    <div className="app">
      <h1>JSONGrep</h1>
      <Playground />
    </div>
  );
}

export default App;
